import settings from '@/constants/constants';
import { useD2DTracking } from '@/hooks/useD2DTracking';
import { usePatientOnboardingDetails } from '@/hooks/usePatientOnboardingDetails';
import { Alert, Link, Stack, Typography } from '@montugroup/design-system';
import { Link as RouterLink, useLocation } from 'react-router-dom';

export const ImmediateConsultConfirmationTitle = () => {
  const { patientOnboardingDetails } = usePatientOnboardingDetails();

  return `An SMS has been sent to ${patientOnboardingDetails?.phoneNumber}`;
};

export const ImmediateConsultConfirmationContent = () => {
  const { search } = useLocation();
  const { trackStartBooking } = useD2DTracking();

  return (
    <Stack gap={4}>
      <Typography>
        Please follow the prompts in the SMS to receive your video consult link. Once you receive it, click on the link
        to join your consultation and the doctor will be with you shortly.
      </Typography>
      <Alert severity="info">
        <strong>Calls are recorded and transcribed.</strong> By joining your consult, you agree that your video and
        audio calls with Alternaleaf, including communications via our chat feature, may be recorded and transcribed for
        safety, quality and training purposes. Your information will be handled in accordance with our{' '}
        <Link href={settings.videoConsult.privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </Link>
      </Alert>
      <Typography>
        Didn&apos;t receive an SMS or having trouble? Schedule a consult{' '}
        <Link
          component={RouterLink}
          to={`/consult-eligible-doctor/schedule${search}`}
          aria-label="Schedule a consult instead"
          onClick={() => trackStartBooking('Initial D2D Consultation')}
        >
          here
        </Link>{' '}
        instead.
      </Typography>
    </Stack>
  );
};
